export default __webpack_public_path__ + "static/media/american_express_logo.93513554.svg";